import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';

@Injectable()
export class OnboardingPayrollService {
  private api = inject(ApiGateway);

  savePreferredPayrollIntegration(preferredPayrollIntegration: string, skipEmail: boolean) {
    return this.api.post('onboarding/payroll', { preferredPayrollIntegration, skipEmail });
  }
}
